export const incrementaContPendencia = ( values ) => {

    if (!values.contPendencia) {
        
        values.contPendencia = 0
    }

    values.contPendencia += 1
}